import React from 'react';
import { AlertTriangle, ExternalLink } from 'lucide-react';

// payRows: values from usePayPreview().byKey — dedupes drivers lacking a payroll pay structure.
export const missingPayDrivers = (byKey) => {
  const seen = {};
  Object.values(byKey || {}).forEach((r) => {
    if (r && r.driver_record_id && r.has_pay_structure === false) {
      seen[r.driver_record_id] = { id: r.driver_record_id, name: r.driver_name || 'Driver' };
    }
  });
  return Object.values(seen);
};

export const PayStructureNudge = ({ drivers, compact = false }) => {
  if (!drivers || !drivers.length) return null;
  return (
    <div
      data-testid="pay-structure-nudge"
      className={`bg-amber-50 border border-amber-300 rounded-md ${compact ? 'px-3 py-2' : 'p-3'} text-xs text-amber-900 flex items-start gap-2`}
      style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}
    >
      <AlertTriangle className="w-4 h-4 text-amber-600 flex-shrink-0 mt-0.5" />
      <div className="flex-1">
        <p className="font-semibold">
          {drivers.length === 1 ? `${drivers[0].name} has` : `${drivers.length} drivers have`} no payroll pay structure — payroll will calculate <strong>$0</strong> for {drivers.length === 1 ? 'their' : 'these'} loads until it&apos;s set.
        </p>
        <div className="mt-1 flex flex-wrap gap-2">
          {drivers.map((d) => (
            <a
              key={d.id}
              href={`/drivers/${d.id}?setup=pay`}
              target="_blank"
              rel="noreferrer"
              data-testid={`pay-structure-nudge-link-${d.id}`}
              className="inline-flex items-center gap-1 px-2 py-1 rounded bg-white border border-amber-300 text-amber-900 font-semibold hover:bg-amber-100"
            >
              Set up pay for {d.name} <ExternalLink className="w-3 h-3" />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};
